<template>
  <div id="app">
    <div class="indexContent">
      <div class="indexInfo"> 
        <div class="searchInput">
          <div class="searchText">
            <i></i>
            <form action="" id="myform">
              <input type="serch" v-model="input" @focus="focusShow=true" @keypress="searchGoods" placeholder="搜索网盘文件">
            </form>
            <span v-if="removeShow" @click="clearText"></span>
          </div>
          <div class="cecalBtn" v-if="focusShow" @click="cancelSearch">取消</div>
        </div>
        <div class="hotRecommend">
          <mt-swipe :auto="4000">
            <mt-swipe-item v-for="(item,index) in bannerList" :key="index"><img :src="item.imgurl" alt="" @click="goSearch(item)"></mt-swipe-item>
          </mt-swipe>
        </div>
        <div class="material_library_center">
          <h2>素材中心<span>最近更新于（{{time}}）</span></h2>
          <ul>
            <li v-for="(item,index) in list" :key="index" @click="openPopup(item)" :class="'libraryBj_'+index">
              <img :src="item.iconurl" alt="">
              <span>{{item.name}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <mt-popup v-model="popupVisible" position="bottom">
      <div class="popupBox">
        <h2>{{popupTitle}}</h2>
        <div class="listBox">   
          <div class="leftCategory">
            <div class="categoryItem" v-for="(item,index) in list2" :key="index" :class="{active:index==chooseIndex}" @click="chooseFun(item,index)">
              <span>{{item.name}}</span>
            </div>
          </div>
          <div class="rightList">
            <div class="listItem" v-for="(item,index) in list3" :key="index" :class="{active:index==chooseIndex2}" @click="chooseFun2(item,index)">
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import http from '../common/http.js'
export default {
  data () {
    return {
      focusShow:false,
      removeShow:false,
      list:[],
      popupVisible:false,
      list2:[],
      list3:[],
      popupTitle:'',
      chooseIndex:0,
      chooseIndex2:null,
      input:'',
      bannerList:[],
      time:'',
    }
  },
  mounted() {
    sessionStorage.setItem('token',this.getUrl())
    this.getFilesFun()
    this.getBanner()
    this.getTime()
  },
  methods:{
    getUrl(){
      let name, value, str = location.href, num = str.indexOf("?"); //取得整个地址栏
      str = str.substr(num + 1); //取得所有参数 stringvar.substr(start [, length ]
      let arr = str.split("&"); //各个参数放到数组里
      for (let i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if (num > 0) {
          name = arr[i].substring(0, num);
          value = arr[i].substr(num + 1);
          if (name == 'token') {
            return value
          }
        }
      }
    },
    getTime(){
      http.get('mobile/time').then(res=>{
        if(res.ok){
          this.time=res.data.createat.split('T')[0]
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    searchGoods(event){
      if(event.keyCode == 13){
        event.preventDefault()
        if(this.input!=''){
          this.$router.push({
            name:'download',
            query:{
              searchName:this.input
            }
          })
        }
      }
    },
    goSearch(item){
      this.$router.push({
        name:'download',
        query:{
          searchName:item.name
        }
      })
    },
    openPopup(item){
      this.popupTitle=item.name
      this.popupVisible=true
      this.list2=item.children
      this.sortarr(this.list2)
      this.list3=item.children[0].children
      this.sortarr(this.list3)
      this.chooseIndex=0
    },
    chooseFun(item,index){
      this.chooseIndex=index
      this.chooseIndex2=null
      this.list3=item.children
      this.sortarr(this.list3)
    },
    chooseFun2(item,index){
      this.chooseIndex2=index
      this.$router.push({
        name:'download',
        query:{
          name:item.index
        }
      })
    },
    getBanner(){
      http.get('seafile/ads').then(res=> {
        if(res.ok){
          this.bannerList=res.data
          this.sortarr(this.bannerList)
        }else{
          this.$toast({
            message: res.message,
            position: 'middle',
            duration: 3000
          });
        }
      }).catch(err=> {
        console.log(err)
      });
    },
    sortarr(arr) {
      let keys = "sort";
      let desc = function(x, y) {
        return x[keys] < y[keys] ? 1 : -1; // 降序
      };
      arr.sort(desc);
      return arr;
    },
    getFilesFun(){
      http.get('mobile/getmenu').then(res=> {
        if(res.ok){
          // this.list=res.data.material
          res.data.material.forEach((v)=>{
            if(v.name==='公司介绍'||v.name==='品牌宣传'||v.name==='产品宣传'||v.name==='物料素材'||v.name==='资质认证'||v.name==='防伪查询' || v.name==='培训课件'){
              this.list.push(v)
            }
          })
          this.sortarr(this.list)
        }
      }).catch(err=> {
        console.log(err)
      });
    },
    clearText(){
      this.input=''
      this.focusShow=false
    },
    cancelSearch(){
      this.input=''
      this.focusShow=false
    }
  },
  watch:{
    input(){
      if(this.input){
        this.removeShow=true
      }else{
        this.removeShow=false
        this.focusShow=false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
.indexContent{
    width: 100%;
}
.indexInfo{
    padding:.3rem .4rem 0;
    &.active{
      position: relative;
      top: 0;
      height: .96rem;
    }
}
.hotRecommend{
    width: 100%;
    // height: 2.92rem;
    height: 2.64rem;
    border-radius: .2rem;
    margin-top: .3rem;
}

.material_library_center{
    margin-top: .62rem;
    h2{
      font-size: .4rem;
      line-height: .56rem;
      span{
        float: right;
        font-size: .22rem;
        color: #9DA4B3;
        font-weight: 100;
      }
    }
    ul{
      padding: .2rem 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: baseline;
      li{
        width: 48.8%;
        height: 1.4rem;
        border-radius: .2rem;
        display: flex;
        align-items: center;
        margin-bottom: .22rem;
        margin-right: .16rem;
        padding-left: .58rem;
        &:nth-child(2n){
          margin-right: 0;
        }
        img{
          display: block;
          width: .52rem;
          height: .52rem;
          margin-right: .32rem;
          margin-top: .08rem;
        }
        span{
          font-size: .28rem;
          color: #fff;
          font-weight: bold;
        }
        &.libraryBj_0{
          background: url('../image/Ban1@2x.png') no-repeat center/cover;
        }
        &.libraryBj_1{
          background: url('../image/Ban2@2x.png') no-repeat center/cover;
        }
        &.libraryBj_2{
          background: url('../image/Ban3@2x.png') no-repeat center/cover;
        }
        &.libraryBj_3{
          background: url('../image/Ban4@2x.png') no-repeat center/cover;
        }
        &.libraryBj_4{
          background: url('../image/Ban5@2x.png') no-repeat center/cover;
        }
        &.libraryBj_5{
          background: url('../image/Ban6@2x.png') no-repeat center/cover;
        }
        &.libraryBj_6{
          background: url('../image/Ban7@2x.png') no-repeat center/cover;
        }
        &.libraryBj_7{
          background: url('../image/Ban8@2x.png') no-repeat center/cover;
        }
        &.libraryBj_8{
          background: url('../image/Ban9@2x.png') no-repeat center/cover;
        }
        &.libraryBj_9{
          background: url('../image/Ban9@2x.png') no-repeat center/cover;
        }
        &.libraryBj_10{
          background: url('../image/Ban5@2x.png') no-repeat center/cover;
        }
        &.libraryBj_11{
          background: url('../image/Ban5@2x.png') no-repeat center/cover;
        }
        &.libraryBj_12{
          background: url('../image/Ban8@2x.png') no-repeat center/cover;
        }
        &.libraryBj_13{
          background: url('../image/Ban9@2x.png') no-repeat center/cover;
        }
      }
    }
}
.popupBox{
    width: 100%;
    height: 9.34rem;
    h2{
      font-size: .36rem;
      padding-left: .4rem;
      height: 1.26rem;
      line-height: 1.26rem;
      border-bottom: 1px solid #F3F4F6;
    }
    .listBox{
      width: 100%;
      height: 100%;
      display: flex;
      .leftCategory{
        // width: 2.58rem;
        width: 2.8rem;
        padding: .4rem .3rem 1.4rem;
        overflow: auto;
        border-right: 1px solid #F3F4F6;
        .categoryItem{
          margin-bottom: .28rem;
          line-height: .56rem;
          span{
            display: block;
            width: 2.3rem;
            height: .56rem;
            line-height: .56rem;
            padding-left: .26rem;
            font-size: .28rem;
            color: #000;
          }
          &.active span{
            background: #F3F4F6;
            border-radius: .08rem;
            font-weight: 900;
          }
        }
      }
    }
}
.popupBox .listBox .rightList{
    flex: 1;
    padding: .4rem 0 1.4rem .46rem;
    overflow: auto;
    font-size: .26rem;
    .listItem{
      margin-bottom: .3rem;
      padding-right: .1rem;
      span{
        display: block;
        height: .56rem;
        line-height: .56rem;
        overflow: hidden;
        text-overflow:ellipsis; 
        white-space: nowrap; 
      }
      &.active span{  
        color: #79ACFF;
      }
    }
}
</style>


